import { createSlice } from "@reduxjs/toolkit";

const getStored = (key, fallback) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "");
  } catch {
    return fallback;
  }
};

const initialState = {
  savedJobIds: getStored("staywork_saved_jobs", []),
  applications: getStored("staywork_applications", []),
};

const persist = (state) => {
  localStorage.setItem(
    "staywork_saved_jobs",
    JSON.stringify(state.savedJobIds),
  );
  localStorage.setItem(
    "staywork_applications",
    JSON.stringify(state.applications),
  );
};

const jobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    toggleSavedJob: (state, action) => {
      const index = state.savedJobIds.indexOf(action.payload);
      if (index >= 0) state.savedJobIds.splice(index, 1);
      else state.savedJobIds.push(action.payload);
      persist(state);
    },
    applyToJob: (state, action) => {
      if (!state.applications.some((item) => item.jobId === action.payload)) {
        state.applications.unshift({
          jobId: action.payload,
          status: "Submitted",
          appliedAt: new Date().toISOString().slice(0, 10),
        });
        persist(state);
      }
    },
  },
});
export const { toggleSavedJob, applyToJob } = jobsSlice.actions;
export default jobsSlice.reducer;
